import { RotateCw, TriangleAlert } from 'lucide-react';
import { useAnyQueryStuck } from '../../lib/useCachedQuery';
import { neuLadenTaste } from '../../lib/platform';

// Seitenweiter Hinweis, wenn gerade etwas nicht durchkommt.
//
// Jede Liste sagt für sich bereits Bescheid, wenn sie leer bleibt. Nicht
// abgedeckt war der Fall, in dem schon Inhalt auf dem Schirm steht und nur die
// Aktualisierung hängt — dann passiert sichtbar nichts und niemand weiß, ob es
// noch lädt oder klemmt. Diese Leiste erscheint deshalb auf JEDER Seite,
// sobald irgendeine Abfrage ungewöhnlich lange braucht, und nennt den Ausweg
// samt richtigem Tastenkürzel fürs Gerät.
export function LoadingHint() {
  const haengt = useAnyQueryStuck();
  if (!haengt) return null;
  return (
    <div role="status" style={leiste}>
      <TriangleAlert size={15} style={{ flex: 'none' }} />
      <span>
        Daten werden gerade geladen – das dauert länger als sonst. Falls nichts
        erscheint: einmal neu laden (<strong>{neuLadenTaste()}</strong>).
      </span>
      <button onClick={() => window.location.reload()} style={knopf}>
        <RotateCw size={13} /> Neu laden
      </button>
    </div>
  );
}

const leiste: React.CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
  padding: '8px 14px', marginBottom: 12, fontSize: 13,
  borderRadius: 'var(--radius-sm)',
  color: 'var(--ton-gelb)',
  background: 'color-mix(in srgb, var(--ton-gelb) 10%, var(--surface))',
  border: '1px solid color-mix(in srgb, var(--ton-gelb) 30%, transparent)',
};
const knopf: React.CSSProperties = {
  marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 5,
  padding: '4px 10px', fontSize: 13, cursor: 'pointer',
  borderRadius: 'var(--radius-sm)', color: 'inherit',
  background: 'transparent',
  border: '1px solid color-mix(in srgb, var(--ton-gelb) 45%, transparent)',
};
